import { DeleteNotesPermanentlyModal } from "@/components/modal/delete-notes-permanently/delete-notes-permanently-modal";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";
import {
  MDSButton,
  MDSButtonVariant,
  MDSText,
  MDSTextColor,
  MDSBanner,
  MDSBannerKind,
  MDSBannerSlotName,
  MDSButtonGroup,
  MDSIconKind,
  MDSTextWeight,
} from "@/mds";
import { INoteObservable } from "@/store/note/types";
import { TemplateObservable } from "@/store/templates/TemplateObservable";
import { observer } from "mobx-react-lite";

export const NoteTopBarTrashedNoteBanner = observer<{
  note: INoteObservable;
}>(({ note }) => {
  const notesViewPage = useTabPageStore("notesViewPage");
  const deletePermanentlyModal = notesViewPage.deleteNotePermanentlyModal;
  return (
    <MDSBanner
      kind={MDSBannerKind.Default}
      iconKind={MDSIconKind.Trash}
      message="This note is in trash"
    >
      {note.isOwnedByMe && (
        <MDSButtonGroup slot={MDSBannerSlotName.Right}>
          {!(note instanceof TemplateObservable) && (
            <MDSButton
              onClick={async () => await note.restoreFromTrash()}
              variant={MDSButtonVariant.Transparent}
            >
              Restore
            </MDSButton>
          )}
          <MDSButton
            onClick={() => deletePermanentlyModal.open({ notes: [note] })}
            variant={MDSButtonVariant.Transparent}
          >
            <MDSText color={MDSTextColor.Danger} weight={MDSTextWeight.SemiBold}>
              Delete
            </MDSText>
          </MDSButton>
          <DeleteNotesPermanentlyModal store={deletePermanentlyModal} />
        </MDSButtonGroup>
      )}
    </MDSBanner>
  );
});
